import { render } from "./PagePendaftaran.vue?vue&type=template&id=664839b5"
import script from "./PagePendaftaran.vue?vue&type=script&lang=js"
export * from "./PagePendaftaran.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__